import React from 'react';

import house from '../assets/house.png';
import hand from '../assets/hand.png';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {useLocation} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';

// Compact hero: image capped in height (object-fit cover) with the slogan
// as real text. Shown on the home page only — portfolio/contact keep their
// content above the fold.
export const TopBanner = () => {
	const {pathname} = useLocation();
	if (pathname !== '/' && pathname !== '/aboutus') return null;

	return (
		<Box sx={{
			position: 'relative',
			width: '100%',
			height: {xs: '260px', sm: '300px', md: 'clamp(300px, 30vw, 440px)'},
			overflow: 'hidden',
		}}>
			<Box component="img" src={house} alt="Smart home"
			     sx={{
				     position: 'absolute',
				     inset: 0,
				     width: '100%',
				     height: '100%',
				     objectFit: 'cover',
				     objectPosition: {xs: '65% center', md: 'center 40%'},
			     }}/>
			<Box component="img" src={hand} alt=""
			     sx={{
				     position: 'absolute',
				     top: 0,
				     right: 0,
				     height: '105%',
				     display: {xs: 'none', lg: 'block'},
			     }}/>
			<Box sx={{
				position: 'absolute',
				inset: 0,
				background: 'linear-gradient(90deg, rgba(255,255,255,0.94) 0%, rgba(255,255,255,0.82) 32%, rgba(255,255,255,0) 65%)',
			}}/>
			<Box sx={{
				position: 'relative',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				paddingLeft: {xs: 3, sm: 6, md: 10},
				maxWidth: '640px',
			}}>
				<Typography component="h1" sx={{
					fontWeight: 800,
					color: '#58595b',
					lineHeight: 1.05,
					fontSize: {xs: '1.9rem', sm: '2.6rem', md: '3.2rem'},
					letterSpacing: '0.02em',
				}}>
					DRIVER<br/>DEVELOPMENT
				</Typography>
				<Typography sx={{
					color: '#60cc29',
					fontSize: {xs: '1rem', sm: '1.25rem', md: '1.4rem'},
					paddingTop: 1,
				}}>
					With more than <Box component="span" sx={{fontWeight: 700}}>10 years</Box> of experience
				</Typography>
				<Box sx={{paddingTop: {xs: 2, md: 3}}}>
					<Button variant="contained" size="large" component={HashLink} smooth
					        to="/portfolio#portfolioBrowser"
					        sx={{borderRadius: 5, fontWeight: 700, paddingLeft: 4, paddingRight: 4}}>
						OUR&nbsp;PORTFOLIO
					</Button>
				</Box>
			</Box>
		</Box>
	);
};
